<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="container small-margin-v-s">
          <div v-bind:class="{ 'airline-information': true, show: !showFlights }" @click.stop>
            <div class="title">{{ $t('rsvpEdit.chooseAirline') }}</div>
            <div class="airline-container">
              <input type="text" class="field-text" :placeholder="$t('rsvpEdit.search')" v-model="airlineSearch" @keyup="filterAirlines" />
              <div class="airlines">
                <div class="airline" v-for="airline in filteredAirlines" @click="chooseAirline(airline)">
                  <span>{{ airline.name }}</span>
                  <span>({{ airline.code }})</span>
                </div>
              </div>
            </div>
          </div>

          <div v-bind:class="{ 'flight-information': true, show: showFlights }" @click.stop>
            <div class="title">{{ $t('rsvpEdit.chooseFlight') }}</div>
            <div class="back-button" @click="showFlights = false"><i class="fa fa-chevron-left"></i></div>
            <div class="loaderx" v-show="loadingFlights">
              <div class="icon"><i class="fa fa-2x fa-circle-notch fa-spin"></i></div>
              <div class="text margin-t-xs">{{ loadingMessage }}</div>
            </div>
            <div class="airline-container" v-show="!loadingFlights">
              <div v-show="!showFlightInput">
                <input type="text" class="field-text" :placeholder="$t('rsvpEdit.search')" v-model="flightSearch" @keyup="filterFlights" />
                <div class="airlines">
                  <div class="airline" @click="showFlightInput = true">
                    <a href="javascript:;">{{ $t('rsvpEdit.cantFindFlight') }}</a>
                  </div>
                  <div class="airline" v-for="(flight, i) in filteredFlights" @click="chooseFlight(flight)" :key="i">
                    <span>{{ flight.label }}</span>
                    <div v-html="flight.fromTo"></div>
                  </div>
                </div>
              </div>
              <div v-show="showFlightInput" class="flight-input-manual">
                <input type="text" class="field-text margin-b-z" :placeholder="$t('rsvpEdit.typeFlight')" v-model="flightInput" />
                <div class="error-message" v-show="flightInputError">{{ $t('rsvpEdit.fieldRequired') }}</div>

                <transition name="slide-up">
                  <div v-show="showFlightInput && !loadingFlights" class="margin-t-s">
                    <label class="flight-intl">
                      <input type="checkbox" v-model="isDomestic"/>
                      {{ $t('rsvpEdit.domesticFlight') }}
                    </label>
                    <!-- <a class="op-btn btn-block btn-success margin-b-s" @click="setCustomFlight">Submit</a> -->
                    <a class="op-btn btn-lg btn-block btn-success" href="javascript:;" @click="submitFlight">{{ $t('common.submit') }}</a>
                  </div>
                </transition>

                <!-- <div class="airlines margin-t-s">
                  <a class="op-btn btn-lg btn-block btn-success" href="javascript:;" @click="submitFlight">Submit</a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'flight-information',
  data () {
    return {
      airlineSearch: '',
      filteredAirlines: [],
      selectedAirline: null,
      showFlights: false,
      loadingFlights: false,
      loadingMessage: '',
      flightSearch: '',
      flights: [],
      filteredFlights: [],
      showFlightInput: false,
      flightInput: '',
      flightInputError: false,
      isDomestic: true
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.flightInfo.show },
    airlines () { return this.$store.state.rsvpEdit.flightInfo.airlines }
  },
  methods: {
    close () { this.$store.commit('rsvpEdit/hideFlightInfo') },
    filterAirlines () {
      let self = this
      let regex = new RegExp('^' + self.airlineSearch, 'i')
      let result = []
      let list = self.airlines

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].name)) { continue }
        result.push(list[i])
      }
      self.filteredAirlines = result
    },
    filterFlights () {
      let self = this
      let regex = new RegExp('^' + self.flightSearch, 'i')
      let result = []
      let list = self.flights

      if (list.length < 0) { return } // Manual

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].number)) { continue }
        result.push(list[i])
      }
      self.filteredFlights = result
    },
    chooseAirline (airline) {
      let self = this
      self.showFlights = true
      self.selectedAirline = airline
      self.loadFlights()
    },
    loadFlights () {
      let self = this
      let airline = self.selectedAirline
      let rsvp = self.$store.state.rsvpEdit.editedRsvp
      let date = moment(self.$store.state.rsvpEdit.flightInfo.flightTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let airportCode = rsvp.pickup.airportCode || rsvp.dropoff.airportCode
      let url = '/availability/flights?airport=' + airportCode +
        '&airline=' + airline.code +
        '&date=' + date.format('YYYY-MM-DD') +
        '&time=' + date.format('HH:mm')
      if (rsvp.pickup.geofenceType === 'airport') {
        url += '&departure=0'
      } else if (rsvp.dropoff.geofenceType === 'airport') {
        url += '&departure=1'
      }
      url += '&adjust=0'
      self.loadingMessage = `${self.$t('rsvpEdit.lookingFor')} ${airline.name} ${self.$t('rsvpEdit.flights')}...`
      self.loadingFlights = true
      self.$sdk.get(self, url, {}, r => {
        self.loadingFlights = false
        self.showFlightInput = false
        if (r.error) {
          self.showFlightInput = true
          return
        }

        if (r.list.length <= 0) {
          self.showFlightInput = true
          return
        }
        let result = []
        for (let i = 0; i < r.list.length; i++) {
          let data = r.list[i]
          let from = moment.tz(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD hh:mmA')
          let to = moment.tz(data.arrival.time.unix, 'X', data.arrival.time.timezone).format('MM/DD hh:mmA')
          let flightData = {
            number: data.flight.number,
            name: data.airline.code + ' ' + data.flight.number + ' ' +
              data.departure.airportCode + '-' + data.arrival.airportCode,
            label: `${data.airline.code} ${data.flight.number} - ${data.airline.name}`,
            fromTo: `${data.departure.airportCode} (${from}) <i class="fas fa-chevron-right margin-h-xs"></i> ${data.arrival.airportCode} (${to})`,
              // data.departure.airportCode + '-' + data.arrival.airportCode,
            isDomestic: data.isDomestic === 1
          }
          if (rsvp.pickup.geofenceType === 'airport') {
            flightData.time = moment(data.arrival.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          } else if (rsvp.dropoff.geofenceType === 'airport') {
            flightData.time = moment(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          }

          result.push(flightData)
        }
        self.flights = result
        self.filteredFlights = result
      })
    },
    chooseFlight (flight) {
      let self = this
      self.$store.commit('rsvpEdit/setEditedFlight', {
        airlineCode: self.selectedAirline.code,
        airline: self.selectedAirline.name,
        flightNumber: flight.number
      })
      let date = moment(flight.time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      // date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      this.$store.commit('rsvpEdit/setSuggestedTime', date)
      this.$store.commit('rsvpEdit/setSuggestedTimeIsDomestic', flight.isDomestic)

      self.close()
    },
    submitFlight () {
      let self = this
      self.flightInputError = false
      if (self.flightInput === '') {
        self.flightInputError = true
        return
      }
      let date = moment(self.$store.state.rsvpEdit.flightInfo.flightTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      // date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      self.$store.commit('rsvpEdit/setSuggestedTime', date)

      self.$store.commit('rsvpEdit/setEditedFlight', {
        airlineCode: self.selectedAirline.code,
        airline: self.selectedAirline.name,
        flightNumber: self.flightInput
      })

      self.$store.commit('rsvpEdit/setSuggestedTimeIsDomestic', self.isDomestic)

      // let rsvp = self.$store.state.rsvpEdit.editedRsvp
      // let airportCode = rsvp.pickup.airportCode
      // let airlineCode = self.selectedAirline.airlineCode || self.$store.state.rsvpEdit.editedRsvp.airlineCode
      // let date = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      // if (rsvp.pickup.geofenceType !== 'airport' && rsvp.dropoff.geofenceType === 'airport') {
      //   airportCode = rsvp.dropoff.airportCode
      //   // date = date.add(3, 'hours')
      // }
      // let sdkUrl = '/availability/flights/' + airlineCode + self.flightInput +
      //   '?airport=' + airportCode +
      //   '&date=' + date.format('YYYY-MM-DD') +
      //   '&time=' + date.format('HH:mm')
      // if (rsvp.pickup.geofenceType === 'airport') {
      //   sdkUrl += '&departure=0'
      // } else if (rsvp.dropoff.geofenceType === 'airport') {
      //   sdkUrl += '&departure=1'
      // }
      // self.$store.commit('rsvpEdit/setFlightLoading', true)
      // self.$sdk.get(self, sdkUrl, {}, res => {
      //   self.$store.commit('rsvpEdit/setFlightLoading', false)
      //   if (!res.error) {
      //     let date = ''
      //
      //     if (rsvp.pickup.geofenceType === 'airport') {
      //       date = moment(res.arrival.time.string, 'YYYY-MM-DD ' + featureToggle.timeFormat(this, false))
      //     } else if (rsvp.dropoff.geofenceType === 'airport') {
      //       date = moment(res.departure.time.string, 'YYYY-MM-DD ' + featureToggle.timeFormat(this, false))
      //     }
      //
      //     // let date = moment(item.time, 'MM/DD/YYYY HH:mm')
      //     date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      //     self.$store.commit('rsvpEdit/setSuggestedTime', date)
      //     self.$store.commit('rsvpEdit/setSuggestedTimeIsDomestic', res.isDomestic)
      //   } else {
      //     self.$store.commit('rsvpEdit/setSuggestedTime', '')
      //   }
      // })

      self.close()
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      let self = this
      self.showFlights = false
      self.airlineSearch = ''
      self.filteredAirlines = self.airlines
      self.flightSearch = ''
      self.showFlightInput = false
      self.flightInput = ''
      self.flightInputError = false
    },
    airlines (value) {
      this.filteredAirlines = value
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  max-width: 350px;
  margin: 10px auto;
  position: relative;
  height: 530px;
  overflow: hidden;
}
.airline-information,
.flight-information {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  transition: all 250ms;
  -webkit-transition: all 250ms;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }
}

.airline-information{
  left: -102%;
  &.show { left: 0; }
}

.flight-information{
  left: 102%;
  &.show { left: 0 }
}

.airlines {
  height: 400px;
  overflow-y: auto;
  border-top: 1px solid rgba(0,0,0,0.15);

  & .airline {
    padding: 10px 0;
    border-bottom: 1px solid rgba(0,0,0,0.15);
    cursor: pointer;
    background-color: #fff;
    transition: all 250ms;
    -webkit-transition: all 250ms;

    &:hover{ background-color: #f5f5f5; }
    div{
      font-size: 13px;
      color: #6f767c;
    }
  }
}

.back-button {
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
  padding: 12px;
}

.loaderx{
  height: 450px;
  text-align: center;
  padding-top: 170px;
  & .icon { color: #777; }
}

.flight-input-manual > input { margin-bottom: 0 !important; }
.error-message {
  background-color: #EB5837;
  color: #fff;
  padding: 5px;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
}

.flight-intl{
  display: block;
  margin-bottom: 10px;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .35s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(8px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// FlightInformation.vue?16e3fbe5